/** Small pending uploads are responsive; slow jobs do not poll every two seconds. */
export function processingPollDelay(elapsedMs: number): number {
  if (elapsedMs < 60_000) return 2_000;
  if (elapsedMs < 5 * 60_000) return 10_000;
  return 30_000;
}

/** Own connections/timers only while visible, releasing them on hide or unmount. */
export function whilePageVisible(
  start: () => () => void,
  page: Pick<Document, "hidden" | "addEventListener" | "removeEventListener"> = document,
): () => void {
  let stop: (() => void) | undefined;
  const update = () => {
    if (page.hidden) {
      stop?.();
      stop = undefined;
    } else if (!stop) {
      stop = start();
    }
  };
  page.addEventListener("visibilitychange", update);
  update();
  return () => {
    page.removeEventListener("visibilitychange", update);
    stop?.();
    stop = undefined;
  };
}
